module.exports = __webpack_public_path__ + "img/sort-black.ead29da1.svg";